/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { AuthAmplifyService } from "src/app/shared/service/auth-amplify.service";
import { CommonAlertModalComponent } from "../common-alert-modal/common-alert-modal.component";

@Component({
  selector: "app-authorize",
  templateUrl: "./authorize.component.html",
  styleUrls: ["./authorize.component.scss"],
  standalone: true,
  imports: [CommonAlertModalComponent],
})
export class AuthorizeComponent {
  private readonly router = inject(Router);
  private readonly authAmplifyService = inject(AuthAmplifyService);
  private readonly route = inject(ActivatedRoute);

  tokenDetails: any;
  token: any;
  previousUrl: any;
  subscribeFormData: any;
  errortriggered: boolean = false;
  isCancelVisible: boolean = false;
  proxyAuth: string = environment.proxyUrl
  code: any;
  constructor() {
    this.route.queryParams.subscribe(params => {
      this.code = params['code'];
      if (this.code) {
        this.authAmplifyService.callback(this.code).subscribe(() => {
          this.router.navigate(["/events"]);
        });
      }
    });
  }



  async removeIndexedDb() {
    const dbs = await window.indexedDB.databases()
    dbs.forEach((db: any) => { window.indexedDB.deleteDatabase(db.name) })
  }

  clearData() {
    window.localStorage.clear();
    window.sessionStorage.clear();
    this.clearAllCookies();
  }

  clearAllCookies() {
    const cookies = document.cookie.split(";");

    for (const element of cookies) {
      const cookie = element;
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
    }
  }

  getRoleGroup(jwt: string) {
    try {
      return JSON.parse(atob(jwt.split(".")[1]));
    } catch {
      return null;
    }
  }
}
